export default [
    {
        path: '/grants',
        name: 'grants',
        component: () => import('../../pages/grants/IndexPage.vue'),
        meta: {
            title: 'Persisted Grants',
            requiresAuth: true,
        },
    },
]
